module.exports = __webpack_public_path__ + "img/foto_8.17b6b85a.png";